import { render, staticRenderFns } from "./studentBi.vue?vue&type=template&id=170b7989&scoped=true&"
import script from "./studentBi.vue?vue&type=script&lang=js&"
export * from "./studentBi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170b7989",
  null
  
)

export default component.exports